import { Carousel, CarouselProps } from '@mantine/carousel';
import { forwardRef } from 'react';
import classes from './VCarousel.module.css';
import clsx from 'clsx';

interface VCarouselProps extends CarouselProps {
  controlOffset?: number;
  controlsBottomOffset?: number;
}

const VCarouselComponent = forwardRef<HTMLDivElement, VCarouselProps>(
  ({ controlOffset = 20, controlsBottomOffset = 0, classNames, style, ...props }, ref) => {
    const classNamesObject = typeof classNames === 'object' ? classNames : undefined;
    const { control: consumerControl, controls: consumerControls, ...restClassNames } = classNamesObject ?? {};

    return (
      <Carousel
        ref={ref}
        classNames={{
          control: clsx(classes.vCarouselControl, consumerControl),
          controls: clsx(classes.vCarouselControls, consumerControls),
          ...restClassNames,
        }}
        style={
          {
            '--v-carousel-control-offset': `${controlOffset}px`,
            '--v-carousel-controls-bottom-offset': `${controlsBottomOffset}px`,
            ...style,
          } as React.CSSProperties
        }
        {...props}
      />
    );
  },
);

export const VCarousel = Object.assign(VCarouselComponent, { Slide: Carousel.Slide });
